import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import { LoadingIndicator } from 'ui-components/components/loading-indicator';
import { Button } from 'ui-components/components/button/';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';
import { useAsyncSafeState } from 'ui-components/hooks/async-safe';

import { unlockUser } from '../../../../../store/user/user.api';

import messages from './messages';
import styles from './styles.module.less';

const unlockRequestStates = {
  noRequest: 'noRequest',
  requesting: 'requesting',
  requestSuccess: 'requestSuccess',
  requestFailure: 'requestFailure',
};

const AccountLocked = ({ userId = '', refreshUserGrid }) => {
  const [requestUnlockState, setRequestUnlockState] = useAsyncSafeState(unlockRequestStates.noRequest);
  const unlock = useCallback(() => {
    setRequestUnlockState(unlockRequestStates.requesting);
    unlockUser(userId)
      .then(() => {
        setRequestUnlockState(unlockRequestStates.requestSuccess);
        refreshUserGrid();
      })
      .catch(() => setRequestUnlockState(unlockRequestStates.requestFailure));
  }, [userId, setRequestUnlockState, refreshUserGrid]);

  return (
    <div className={styles['account-locked']}>
      {(requestUnlockState === unlockRequestStates.noRequest || requestUnlockState === unlockRequestStates.requesting) && (
        <b>
          <FormattedMessage {...messages.lockedOutMessage} />
        </b>
      )}
      {requestUnlockState === unlockRequestStates.requestSuccess && (
        <div className={styles.ok}>
          <FormattedMessage {...messages.unlockSuccessMessage} />
        </div>
      )}
      {requestUnlockState === unlockRequestStates.requestFailure && (
        <div className={styles.danger}>
          <FormattedMessage {...messages.unlockFailureMessage} />
        </div>
      )}
      {(requestUnlockState === unlockRequestStates.noRequest || requestUnlockState === unlockRequestStates.requestFailure) && (
        <Button onClick={unlock} theme={THEME_CONSTANTS.tertiary}>
          <FormattedMessage {...messages.unlockAccount} />
        </Button>
      )}
      {requestUnlockState === unlockRequestStates.requesting && <LoadingIndicator className={styles.loading} />}
    </div>
  );
};

AccountLocked.propTypes = {
  userId: PropTypes.string,
  refreshUserGrid: PropTypes.func.isRequired,
};

export default AccountLocked;
